// extracted by mini-css-extract-plugin
export default {"container":"nJ-z","error":"oJ-z","disabled":"pJ-z","submit":"qJ-z","option":"rJ-z","success":"sJ-z","failure":"tJ-z"};